import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NoPage from './components/NoPage/NoPage';
import DerekPage from './components/DerekPage/DerekPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<DerekPage />} />
        <Route path="derek" element={<DerekPage />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
